import { defaultTheme } from 'react-admin';


const Theme =  {
    ...defaultTheme,
    palette: {
        mode: 'light',
        primary: {
            main: '#09AFDC'
        },
        secondary: {
            light: '#013c01',
            main: '#09AFDC',
            dark: '#000e00',
            contrastText: '#fff',
        }
    },
    typography: {
        fontFamily: [
            '-apple-system',
            'BlinkMacSystemFont',
            '"Segoe UI"',
            'Arial',
            'sans-serif',
        ].join(',')
    },
    components: {
        ...defaultTheme.components,
        MuiFilledInput: {
            root: {
                backgroundColor: 'rgba(0, 0, 0, 0.04)',
                '&$disabled': {
                    backgroundColor: 'rgba(0, 0, 0, 0.04)',
                },
            },
        },
        MuiTabs: {
            root: {
                ['@media print']: { // eslint-disable-line no-useless-computed-key
                    display: 'none'
                    }
            }
        },
        MuiToolbar: {
            root: {
                ['@media print']: { // eslint-disable-line no-useless-computed-key
                    display: 'none !important'
                    }
            }
        },
        MuiDrawer: {
            paper: {
                background: '#18202c',
                // background: 'white'
            },
        },
        MuiChip: { // override the styles of all instances of this component
            root: { // Name of the rule
                color: 'white', // Some CSS
                backgroundColor: 'rgba(31, 119, 180, 0.59)',
            },
        },
        MuiSelect: {
            root: {
                height: 'auto'
            }
        },
        RaMenuItemLink: {
            root: {
                borderLeft: '3px solid #fff'
                // paddingLeft: '35px'
            },
            active: {
                borderLeft: '4px solid rgb(76, 175, 80)',
                'backgroundColor': '#efefef'
            //     paddingLeft: '35px'
            },
        },
        // MuiMenuItem: {
        //     root: {
        //         // backgroundColor: '#d31145',
        //         '&$selected': {
        //             backgroundColor: 'linear-gradient(45deg, red 30%, orange 90%)',
        //             // color: 'white'
        //         },
        //     }
        // }   
    },
};

export default Theme;